import Container from "./container";
export default (Container);
